/* tslint:disable */
/* eslint-disable */
/* @relayHash dfd39a9ca0411b42bfe789a1b2e1941a */

import { ConcreteRequest } from "relay-runtime";
export type shopLocalConfigQueryVariables = {};
export type shopLocalConfigQueryResponse = {
    readonly viewer: {
        readonly shopLocalNotificationFeatureFlag: boolean | null;
    };
};
export type shopLocalConfigQuery = {
    readonly response: shopLocalConfigQueryResponse;
    readonly variables: shopLocalConfigQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": "shopLocalNotificationFeatureFlag",
  "name": "featureFlag",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "shopLocalNotification"
    }
  ],
  "storageKey": "featureFlag(feature:\"shopLocalNotification\")"
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "shopLocalConfigQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "shopLocalConfigQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "shopLocalConfigQuery",
    "id": "app-buyer-misc/262.0.0-2020-04-29T14:06:59.202Z/shopLocalConfigQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '02f69596217db106a6887cd1e300c106';
export default node;
